import dayjs from "dayjs";
import { getSalesWeekFromDate } from "../Insights/helpers";
import { Vote } from "./BackendApiRepository/QuestionResponse";
import {
  FilterValue,
  PeriodFilterValue,
} from "@coworker/apprestructured/src/shared/filters/types/filter";

interface AggregatedVotesType {
  weekNumber?: number;
  bucketStartDate?: string;
  key: number;
  value: number;
}

export function aggregateVotes(votes: Vote[], interval: string) {
  const data = votes?.reduce((result: AggregatedVotesType[], vote: Vote) => {
    const voteValue = vote.vote_value;

    if (interval === "day") {
      const bucketStartDate = dayjs(vote.created_at).format("YYYY-MM-DD");
      const existingItem = result.find(
        (resultItem) => resultItem.bucketStartDate === bucketStartDate
      );

      if (existingItem) {
        existingItem.value += voteValue;
      } else {
        result.push({
          bucketStartDate,
          key: Date.parse(vote.created_at),
          value: voteValue,
        });
      }
    } else if (interval === "week") {
      const weekNumber = getSalesWeekFromDate(dayjs(vote.created_at));
      const existingItem = result.find(
        (resultItem) => resultItem.weekNumber === weekNumber
      );

      if (existingItem) {
        existingItem.value += voteValue;
      } else {
        result.push({
          weekNumber,
          key: Date.parse(vote.created_at),
          value: voteValue,
        });
      }
    }

    return result;
  }, []);

  return data;
}

export function getPeriodTimestampsFromFilters(
  filters: FilterValue[]
): [number, number] {
  const periodFilter = filters.find(
    (f) => f.filterId === "period"
  ) as PeriodFilterValue;
  const periodValue = periodFilter?.value ?? "";

  const now = dayjs();

  switch (periodValue) {
    case "period=7days":
      return [now.subtract(7, "day").startOf("day").valueOf(), now.valueOf()];
    case "period=4weeks":
      return [now.subtract(4, "week").startOf("day").valueOf(), now.valueOf()];
    case "period=custom": {
      const startDate = periodFilter?.startDate
        ? dayjs(periodFilter.startDate).startOf("day").valueOf()
        : now.startOf("day").valueOf();
      const endDate = periodFilter?.endDate
        ? dayjs(periodFilter.endDate).endOf("day").valueOf()
        : now.valueOf();
      return [startDate, endDate];
    }
    default:
      return [now.subtract(7, "day").startOf("day").valueOf(), now.valueOf()];
  }
}
